import CognitoAuthService from "../services/CognitoAuthService";
import { getToken } from "./TokenManager";

/**
 * Manages which token strategy to use (Cognito vs MJWT)
 * This is needed because not all old API calls used MJWT (some used IJWT, etc.)
 */
class TokenStrategyManager {
  constructor() {
    this.useCognito = false; // Default to legacy flow (MJWT) - only use Cognito when SSO is explicitly enabled
  }

  setStrategy(useCognito) {
    this.useCognito = useCognito;
    console.log(`[TokenStrategy] Using ${useCognito ? "Cognito" : "MJWT"}`);
  }

  async getAuthHeader() {
    if (this.useCognito) {
      const token = await CognitoAuthService.getIdToken();
      // Ensure token is a string before using it
      if (token && typeof token === "string") {
        return `Bearer ${token}`;
      }
      console.warn(
        "[TokenStrategy] Cognito token is null or not a string:",
        typeof token,
      );
      return null;
    } else {
      const token = getToken("MJWT");
      // Ensure token is a string before using it
      if (token && typeof token === "string") {
        return `VRS ${token}`;
      }
      console.warn(
        "[TokenStrategy] MJWT token is null or not a string:",
        typeof token,
      );
      return null;
    }
  }
}

export default new TokenStrategyManager();
